export default __webpack_public_path__ + "img/364847608f5533b2fcfe8f8024066217.svg";